<template>
  <div class="footer-wrapper">
    <div class="bg-wrapper-top">
      <div class="top">
        <div class="left">
          <div class="website">
            <img class="logo" src="../../assets/img/pic/pic_logo_rencai1.png" alt="首页" @click="routerGo('index')">
            <label>备受大家欢迎的求职成长平台</label>
          </div>
          <ul class="menu">
            <li
                v-for="(item, index) in menuList"
                :key="index"
                @click="routerGo(item.pathName)"
            >{{ item.title }}</li>
          </ul>
        </div>
        <div class="right">
          <img class="pic-weixin" src="../../assets/img/pic/pic-weixin.png" alt="关注微信公众号">
          <label>广东才汇公众号</label>
        </div>
      </div>
    </div>
    <div class="bg-wrapper-bottom">
      <div class="bottom">
        <label>粤ICP备18161349号-1 Copyright © 广州白云金科控股集团有限公司</label>
        <img class="logo" src="../../assets/img/pic/logo_rencai2.png" alt="图片">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        menuList: [
          { title: '平台公告', pathName: 'news' },
          { title: '帮助中心', pathName: 'help' },
          { title: '关于我们', pathName: 'aboutUs' }
          // { title: '意见反馈', pathName: 'index' }
        ]
      };
    },
    methods: {
      // 路由跳转
      routerGo(pathName) {
        this.$router.push({ name: pathName });
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "Footer.sass"
</style>
